/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * What Apply does with manually-assigned policies. `keep` leaves every manual row as it is and re-resolves only the rest. `overwrite` also replaces a manual row of a policy type when an enabled exception setting that type matches the job; manual rows no exception matches are kept.
 *
 */
export enum ManualEditsDecision {
    KEEP = 'keep',
    OVERWRITE = 'overwrite',
}
